import * as THREE from 'three'
import Experience from '../Experience.js'

export default class Floor
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene

        this.setFloor()
        this.setWalls()
    }

    setFloor()
    {
        const roomWidth = 4.8
        const roomDepth = 3.8
        const roomHeight = 2.8

        this.room = {
            width: roomWidth,
            depth: roomDepth,
            height: roomHeight
        }

        const floorGeometry = new THREE.PlaneGeometry(roomWidth, roomDepth)
        const floorMaterial = new THREE.MeshStandardMaterial({
            color: '#7f7f79',
            roughness: 0.96,
            metalness: 0
        })

        this.floor = new THREE.Mesh(floorGeometry, floorMaterial)
        this.floor.rotation.x = -Math.PI * 0.5
        this.floor.receiveShadow = true
        this.scene.add(this.floor)
    }

    setWalls()
    {
        const { width, depth, height } = this.room
        const wallMaterial = new THREE.MeshStandardMaterial({
            color: '#f2efe7',
            roughness: 0.95,
            metalness: 0
        })

        const backWall = new THREE.Mesh(
            new THREE.PlaneGeometry(width, height),
            wallMaterial
        )
        backWall.position.set(0, height * 0.5, -depth * 0.5)
        backWall.receiveShadow = true
        this.scene.add(backWall)

        const leftWall = new THREE.Mesh(
            new THREE.PlaneGeometry(depth, height),
            wallMaterial
        )
        leftWall.position.set(-width * 0.5, height * 0.5, 0)
        leftWall.rotation.y = Math.PI * 0.5
        leftWall.receiveShadow = true
        this.scene.add(leftWall)

        const rightWall = new THREE.Mesh(
            new THREE.PlaneGeometry(depth, height),
            wallMaterial
        )
        rightWall.position.set(width * 0.5, height * 0.5, 0)
        rightWall.rotation.y = -Math.PI * 0.5
        rightWall.receiveShadow = true
        this.scene.add(rightWall)
    }
}
